module.exports = __webpack_public_path__ + "img/emoji_67.5e95ed25.png";